import { defineComponent as _defineComponent } from 'vue';
import { EnumIroLevelOfImpact, useGetIroQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'impactType',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetIroQuery = useGetIroQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetIroQuery.result,
      onResult = _useGetIroQuery.onResult;
    var initStatusOnce = _.once(function (data) {
      var _data$getIro;
      editing.value = !((_data$getIro = data.getIro) !== null && _data$getIro !== void 0 && _data$getIro.levelOfImpact);
    });
    onResult(function (_ref) {
      var data = _ref.data;
      if (data !== null && data !== void 0 && data.getIro) {
        initStatusOnce(data);
      }
    });
    var item = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getIro) || {};
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      updateIRO = _useUpdateIroMutation.mutate,
      onDone = _useUpdateIroMutation.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
      editing.value = false;
    });
    var editing = ref(false);
    var val = computed(function () {
      if (item.value.levelOfImpact === EnumIroLevelOfImpact.Actual) {
        return 1;
      } else if (item.value.levelOfImpact === EnumIroLevelOfImpact.Potential) {
        return 0;
      }
    });
    return {
      __sfc: true,
      route: route,
      result: result,
      onResult: onResult,
      initStatusOnce: initStatusOnce,
      item: item,
      updateIRO: updateIRO,
      onDone: onDone,
      editing: editing,
      val: val,
      EnumIroLevelOfImpact: EnumIroLevelOfImpact
    };
  }
});